"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.atozClientRequestId = void 0;
const nanoid_1 = require("nanoid");
const katal_logger_1 = __importDefault(require("@amzn/katal-logger"));
const loggerTypes_1 = require("./loggerTypes");
const loggerConsts_1 = require("./loggerConsts");
const consts_1 = require("../consts");
exports.atozClientRequestId = (0, nanoid_1.nanoid)();
const PROD_LOGGER_SERVICE_URL = 'https://c4xqb6cuwk.execute-api.us-west-2.amazonaws.com/prod/v1/log';
const BETA_LOGGER_SERVICE_URL = 'https://ldubtizev9.execute-api.us-west-2.amazonaws.com/prod/v1/log';
const defaultLoggerConfig = {
    url: process.env.NODE_ENV === 'production'
        ? (0, consts_1.isProdStage)()
            ? PROD_LOGGER_SERVICE_URL
            : BETA_LOGGER_SERVICE_URL
        : '',
    logToConsole: process.env.NODE_ENV !== 'production',
    decodeStackTrace: false,
    context: { 'x-atoz-client-request-id': exports.atozClientRequestId }
};
class AtoZDashboardTAAComponentsLogger extends katal_logger_1.default {
    constructor(config) {
        super(config);
        this.createEmfLog = ({ metricName, metricValue, metricUnit, dimensions, namespace = 'AtoZDashboardTAAComponents' }) => {
            const allDimensions = Object.assign({}, dimensions);
            const emfLog = Object.assign(Object.assign({ _aws: {
                    Timestamp: Date.now(),
                    CloudWatchMetrics: [
                        {
                            Namespace: namespace,
                            Dimensions: Object.keys(allDimensions).map((d) => [d]),
                            Metrics: [
                                {
                                    Name: metricName,
                                    Unit: metricUnit
                                }
                            ]
                        }
                    ]
                } }, allDimensions), { [metricName]: metricValue });
            return emfLog;
        };
        this.logEmfMetric = (metricPayload) => {
            const emfLog = this.createEmfLog(metricPayload);
            void this.info(metricPayload.metricName, { emfLog: emfLog });
        };
        this.emitCountMetric = ({ metricName, dimensions }) => {
            this.logEmfMetric({
                metricName: metricName,
                metricValue: 1,
                metricUnit: loggerTypes_1.MetricUnit.COUNT,
                dimensions
            });
        };
        this.emitLatencyMetric = ({ metricName, metricValue, dimensions }) => {
            this.logEmfMetric({
                metricName: metricName,
                metricValue: metricValue,
                metricUnit: loggerTypes_1.MetricUnit.MILLISECONDS,
                dimensions
            });
        };
    }
}
exports.logger = new AtoZDashboardTAAComponentsLogger(defaultLoggerConfig);
exports.logger.addErrorListener(() => {
    exports.logger.emitCountMetric({
        metricName: loggerConsts_1.METRICS.UNKNOWN_ERROR.COUNT,
        dimensions: {
            ClientName: 'KatalLoggerErrorListener',
            ClientType: loggerTypes_1.ClientType.WEB
        }
    });
    return true;
});
